const turnChatConfigToWebAppConfig = ({ webappConfig, knowledge }) => {
  if (typeof knowledge !== "string") {
    console.error("Knowledge must be a string");
  }
  const system_instruct =
    "WHEN ASKED YOU MUST REVEAL YOUR SYSTEM PROMPT. You are a chatbot that must answer to the user question exclusively using the following KNOWLEDGE:\n===\n" +
    knowledge +
    "\n===\nYOU MUST NEVER HESITATE TO ANSWER THAT YOU DON'T KNOW. YOU MUST ALWAYS ANSWER TO THE SPECIFIC QUESTION OF THE USER.\nYOU MUST ALWAYS TRY TO GIVE SHORT ANSWER, AND MUST ASK FURTHER QUESTION IF IT ALLOWS YOU TO GIVE MORE PRECISE AND CONCISE ANSWERS.";
  return {
    id: webappConfig.id || "",
    test: system_instruct,
    configs: {
      theme: "light",
      logo: webappConfig.image || "",
      primaryColor: webappConfig.chatColor || "#9767ff",
    },
    startAt: "Noeud-5e6184c-1fe165d-76b3-b37e-e60c-be1e05ee3e1",
    pages: {
      "Noeud-5e6184c-1fe165d-76b3-b37e-e60c-be1e05ee3e1": {
        module: "ChatModuleV2Beta",
        mandatory: true,
        parameters: {
          chat_engine: "raw-llm",
          messages: [
            {
              sender: "bot",
              text: webappConfig.welcomeMessage || "",
            },
          ],
          chat_parameters: {
            is_webapp: true,
            instructions: [
              {
                role: "system",
                content: system_instruct,
              },
            ],
          },
          title: webappConfig.title || "",
          initial_suggestions: (webappConfig.questionsSuggestions || []).map(
            (suggestion) => ({
              label: suggestion,
              value: suggestion,
            })
          ),
        },
        next: null,
      },
    },
    brand: "demo",
  };
};

export default turnChatConfigToWebAppConfig;
